import CustomerReviewViewModel from "viewModels/customerReview/customerReviewViewModel";
import makeWidgetFor from "../../viewModels/makeWidgetFor";
import { registerWidget } from "../widget";
import InitializationWithOutagesService from "services/initialization/initializationWithOutagesService";

const CustomerReviewWidgetIdentifier = "edaz-customer-review";

registerWidget({
  component: makeWidgetFor(CustomerReviewWidgetIdentifier, [CustomerReviewViewModel], InitializationWithOutagesService),
  configuration: {
    tagname: CustomerReviewWidgetIdentifier,
  },
});
